import { Injectable } from '@angular/core';
import { Brand } from '../models/new/brand.model';

@Injectable({
	providedIn: 'root'
})
export class BrandMapper {
	constructor() {}

	toBrand(brand: any) {
		return new Brand({
			id: brand.id,
			name: brand.name
		});
	}
}
